import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[namePattern]',
  standalone: true
})
export class NamePatternDirective {
  private namePattern = '^[a-zA-Z -]+$';

  constructor(private elRef: ElementRef) {}

  // Block on keypress
  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.namePattern).test(event.key);
  }

  // Block on copy/paste
  @HostListener('paste', ['$event']) blockPaste(event: ClipboardEvent) {
    this.validateFields(event);
  }

  private validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData
      .getData('text/plain')
      .replace(/[^a-zA-Z -]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
